const API_ENDPOINTS = {
  // AUTHENTICATION
  LOGIN: "/login",
  LOGOUT: "/logout",
  REGISTER: "/register",
  GET_USER: "/user/profile",
  UPDATE_USER: "/user/profile",
  FORGOT_PASSWORD: "/forgot-password",
  VERIFY_CODE: "/verify-code",
  RESET_PASSWORD: "user/reset-password",
  CHANGE_PASSWORD: "user/change-password",

  // CAMPAIGNS
  GET_CAMPAIGNS: "/campaigns",

  // SECTION ORDERING (unified pre-selected campaign sections)
  GET_SECTION_ORDERING: (key) => `/section-ordering/${key}`,
  GET_SECTION_LIFE_URGENT: "/section-ordering/life_urgent",
  GET_SECTION_RECENT_CAMPAIGNS: "/section-ordering/recent_campaigns",
  GET_SECTION_HOME_CATEGORIES: "/section-ordering/home_categories",
  GET_CAMPAIGN_BY_SLUG: (slug) => `/campaigns/slug/${encodeURIComponent(slug)}`,
  GET_CAMPAIGN_BY_ID: (id) => `/campaigns/${id}`,
  GET_CAMPAIGN_SHARE_DETAILS: (id) => `/campaigns/${id}/share`,
  CREATE_CAMPAIGN: "/campaigns",
  UPDATE_CAMPAIGN: (id) => `/campaigns/${id}`,
  DELETE_CAMPAIGN: (id) => `/campaigns/${id}`,
  START_CAMPAIGN: "/start-campaigns",

  // BENEFICIARIES (pooled donate-once program)
  GET_BENEFICIARIES: "/beneficiaries",

  // DONATIONS
  MAKE_DONATION: "/user/make-donation",
  DONATION_HISTORY: "/user/donations",
  PAYMENT_TRANSACTION: "/payment/create-transaction",
  PAYMENT_VERIFY: "/api/payment/verify",
  PAYMENT_NOTIFY_FAILED: "/api/payment/notify-failed",
  GET_TOP_DONORS: (campaignId) => `/topDonors/${campaignId}`,
  GET_RECENT_DONORS: "/payment/recent-donors",
  GET_RECENT_TRANSACTIONS: "/recent-transactions",
  
  // AUTO LOGIN & EMAIL
  AUTO_LOGIN: "/auto-login-email",
  SEND_EMAIL: "/send-account-email",

  // BLOGS
  GET_BLOGS: "/blog",
  GET_BLOG_BY_ID: (id) => `/blog/${id}`,
  CREATE_BLOG: "/blog",
  UPDATE_BLOG: (id) => `/blog/${id}`,
  DELETE_BLOG: (id) => `/blog/${id}`,

  // CONTACT & VISIT
  CONTACT_US: "/contact-us",
  PLAN_VISIT: "/visit-request",

  // VOLUNTEER
  CREATE_VOLUNTEER: "/volunteer",
  
  // CMS
  GET_CMS_HOME: "/cms",

  // LIFE PAGE - Start medical fundraiser form
  LIFE_CAMPAIGN_START: "/life-campaign/start",
  
  // WISHLIST
  GET_WISHLIST: "/wishlist",
  
  // USER CAMPAIGN COMMENTS
  POST_USER_CAMPAIGN_COMMENT: "/user-campaign-comments",
  GET_USER_CAMPAIGN_COMMENTS: "/user-campaign-comments",
  
  // MONTHLY DONATIONS
  GET_MONTHLY_DONATIONS: "/monthly-donations",
  GET_MONTHLY_DONATION_BY_ID: (id) => `/monthly-donations/${id}`,
  
  // USER TRANSACTIONS
  GET_USER_TRANSACTIONS: (userId) => `/user/transactions/${userId}`,
  
  // SUBSCRIPTION
  CANCEL_SUBSCRIPTION: "/payment/subscription/cancel",
  
  // 80G Form
  EIGHTYFORM: "/user/get80g",
  
  // 10B Form
  TENBE_LIST: "/user/10bes/:id",
  
  // OTP
  SEND_OTP: "/send-otp",
  VERIFY_OTP: "/verify-otp",
  
  // NEWSLETTER
  SUBSCRIBE_NEWSLETTER: "/newsletter/subscribe",

  // REMINDERS
  CREATE_REMINDER: "/reminders",

  // VENDOR NOMINATIONS
  VENDOR_NOMINATIONS: "/vendor-nominations",
  TEMPLE_NOMINATIONS: "/temple-nominations",
  // Active sub-categories of a category (admin → Categories), e.g. temple
  CATEGORY_SUB_CATEGORIES: (slug) => `/categories/${slug}/sub-categories`,
  TEMPLE_DETAILS: (campaignId) => `/temple-details/${campaignId}`,

  // VENDORS
  VENDORS: "/vendors",
  GET_VENDOR_BY_ID: (id) => `/vendors/${id}`,
  GET_VENDOR_SHARE_DETAILS: (id) => `/vendors/${id}/share`,
};

export default API_ENDPOINTS;
